import { withInstall } from '@vuemap/vue-amap-util'
import LabelMarker from './LabelMarker.vue'

export const ElAmapLabelMarker = withInstall(LabelMarker)
export default ElAmapLabelMarker
